import { useState, useEffect } from "react"
import { Menu, MenuItem, Button } from "@mui/material"
import ArrowDown from "img/arrow-down.svg"
import { CreateComponent } from "components/utils/CreateComponent"
import { appFeatures } from "../../AppFeatures"
import { setLanguage } from "store/lang/L10n"
import { setLanguage as setCoCoLanguage } from "@quickline/coco"
//import classnames from "classnames"

const styles = theme => ({
	NavBarArrowIcon: { padding: 0, marginTop: "-4px" },
	LanguageListLabel: { color: "white", fontSize: 20, display: '-webkit-inline-box', WebkitBoxOrient: "vertical", cursor: "pointer",
								WebkitLineClamp: 1, overflow: 'hidden', textOverflow: 'ellipsis' },
})

// MTVW-1055: language setting
export const LanguageMenu = CreateComponent(styles, false, true, ({ classes, cbOnLanguageChange=null }) => {
	const isoToText = new Map([
		["de", "Deutsch"],
		["fr", "Français"],
		["it", "Italiano"],
		["en", "English"],
		//["gsw", "Bärndütsch"],
	])

	const textToIso = new Map([
		["Deutsch", "de"],
		["Français", "fr"],
		["Italiano", "it"],
		["English", "en"],
		//["Bärndütsch", "gsw"],
	])

	const [anchorEl, setAnchorEl] = useState(null)
	const [isoLang, setIsoLang] = useState(appFeatures.persistedLanguage)
	const [langText, setLangText] = useState(isoToText.get(appFeatures.persistedLanguage))

	const setLang = (languageText) => {
		setLangText(languageText)
		setIsoLang(textToIso.get(languageText))
		const selectedIso = textToIso.get(languageText)
		appFeatures.persistedLanguage = selectedIso
		setLanguage(selectedIso).then((res) => {
			appFeatures.persistedLanguage = selectedIso
			setCoCoLanguage(selectedIso)
			if (cbOnLanguageChange) cbOnLanguageChange(selectedIso)
		})
	}

	const open = Boolean(anchorEl)

	useEffect(() => {
		const selected = isoToText.get(rootStore?.sso?.browserStore?.getLanguage())
		setLangText(selected)
		console.debug("selected language", selected)
	}, [rootStore?.sso?.browserStore?.getLanguage()])

	return (
		<>
		<Button
			id="languageListMenuButton"
			data-test="language_menu_current"
			aria-controls={anchorEl ? 'customized-menu' : undefined}
			disableRipple={true}
			aria-haspopup="true"
			aria-expanded={anchorEl ? 'true' : undefined}
			sx={{ textTransform: "none" }} // no text-transform: uppercase
			onClick={(e) => {
				e.stopPropagation()
				setAnchorEl(e.currentTarget)
			}}
		>
			{/*<img src={ListIcon} className={classes.Icons} alt="Sprachen" />*/}
			<label className={classes.LanguageListLabel} data-test="active_lang_list_name">{langText}</label>
			<img src={ArrowDown} className={classes.NavBarArrowIcon} alt=""></img>
		</Button>
		<Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
			{[isoToText.get("de"), isoToText.get("fr"), isoToText.get("it"), isoToText.get("en")/*, isoToText.get("gsw")*/].map((i) => (
				<MenuItem
				key={i}
				selected={langText === i}
				onClick={() => {
					setLang(i)
					setAnchorEl(null)
				}}
				>
				{i}
				</MenuItem>
			))}
		</Menu>
		</>
	)
})
